import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { AvatarComponent } from '../avatar/avatar.component';
import { User } from 'app/models';
import { ModalService } from 'app/services/modal.service';

@Component({
  selector: 'app-user-description',
  templateUrl: './user-description.component.html',
  styleUrls: ['./user-description.component.scss'],
  standalone: true,
  imports: [AvatarComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class UserDescriptionComponent implements OnChanges {
  @Input() user: User | null = null;

  private readonly modalService: ModalService = inject(ModalService);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['user']?.currentValue) {
      // Remove default dialog header to render a custom one inside the component.
      this.modalService.setTitle('');
    }
  }
}
